/**
 * Compact display name: "Aisha Rahman" → "Aisha.R". Never shows a full email —
 * falls back to the part before the "@". Single words pass through as-is.
 *
 * NOTE: acceptable for private surfaces (practice calls, where partners already
 * see each other), but the email-local-part fallback still leaks a guessable
 * address. Feed surfaces must NOT use this — they render
 * profile.display_name → @handle → "عضو" (see feed components).
 */
export function shortName(raw) {
  let s = (raw || "").trim();
  if (!s) return "";
  if (s.includes("@")) s = s.split("@")[0];
  const parts = s.split(/\s+/);
  const first = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
  if (parts.length === 1) return first;
  return `${first}.${parts[1].charAt(0).toUpperCase()}`;
}

export default shortName;
